// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/rollofeder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteRollofederDE: PageEntry = {
  id: "example.produkte-rollofeder",
  locale: "de",
  slug: "produkte/rollofeder",
  seo: {
    title: "Rollofeder | Dietz GmbH",
    description: "Haltefeder für die Achse eines Hutablagenrollos im Kofferraum. Einfaches Werkzeugkonzept für geringe Stückzahlen und enge Toleranzen im Geformten „Löffel“.",
  },
  type: "post",
  h1: "Rollofeder",
  intro: "Haltefeder für die Achse eines Hutablagenrollos im Kofferraum. Einfaches Werkzeugkonzept für geringe Stückzahlen und enge Toleranzen im Geformten „Löffel“.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_rollofederjpg.jpg", alt: "Rollofeder", width: 800, height: 640 }
  ],
};
